
<app-app-content-page-wrapper *ngIf="competition_service.competitionStore.data[0]"  @fade>
  <ng-container *ngIf="competition_service.competitionStore.data[0] && competition_service.competitionStore.data[0].WithRes">
    <competition-podium [attr.comp-id]="competition_service.competitionStore.data[0].ID" [attr.podium-title]="'Podiums'|transloco" show-team="true" show-individual="true"></competition-podium>
  </ng-container>

<div *ngIf="competition_service.competitionEditorialInformationStore.data?.length > 0" class="editorial-wrapper">
    <h2 #info>
      {{'About' | transloco}}
    </h2>
    <div class="editorial-info" *ngIf="competition_service.competitionEditorialInformationStore.data">
      <app-see-more [elementToScroll]="info" [maxHeightPx]="350">
      <ng-container *ngFor="let information of competition_service.competitionEditorialInformationStore.data">
        <section #editorial class="editorial-content">
          <article [innerHTML]="information.body"></article>
          <div *ngIf="information.date && information.date != '' && information.author">
            <address class="editorial-author">({{'last_update_biography' | transloco}} <ng-container *ngIf="information.author">{{'by' | transloco}}</ng-container> <a> {{information.author}}</a>
              <ng-container>{{'on_date_editorial' | transloco}}
              <time pubdate [attr.datetime]="information.date| date :'dd MMMM yyyy'">
                {{information.date| date :'dd MMMM yyyy'}}.</time>)
              </ng-container>
            </address>

          </div>
        </section>
      </ng-container>
    </app-see-more>
    </div>
  </div>

  <app-event-info-panel [competition_store]="competition_service.competitionStore"></app-event-info-panel>

  <app-bootstrap-competition-documents *ngIf="competition_service.competitionDocumentsStore.data.length > 0 && competition_service.competitionDocumentsStore.data[0].documents.length > 0"></app-bootstrap-competition-documents>

  <app-competition-location-panel [competition]="competition_service.competitionStore.data[0]"></app-competition-location-panel>
